export default [
    {
        path: 'pre-agendamento-transporte',
        component: () => import(/* webpackChunkName: 'pre-agendamento-transporte' */ '@/views/transporte-paciente/pre-agendamento-transporte/Index'),
        redirect: 'pre-agendamento-transporte/index',
        children: [
            {
                name: 'pre-agendamento-transporte-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'pre-agendamento-transporte' */ '@/views/transporte-paciente/pre-agendamento-transporte/List'),
            },
            {
                name: 'pre-agendamento-transporte-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'pre-agendamento-transporte' */ '@/views/transporte-paciente/pre-agendamento-transporte/Form'),
            },
            {
                name: 'pre-agendamento-transporte-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'pre-agendamento-transporte' */ '@/views/transporte-paciente/pre-agendamento-transporte/Form'),
            },
        ]
    }
]